import styled from "styled-components";

export const StyledPageHeader = styled.h1`
  font-style: normal;
  font-weight: 700;
  font-size: 3rem;

  @media only screen and (max-width: 460px) {
    font-size: 2.4rem;
  }
`;

export const StyledPageWrapper = styled.div`
  margin-top: 1.5rem;

  .main-area {
    flex: 2 1 0;
    // max-width: 65%;
  }

  .widget-area {
    flex: 1 1 0;
  }

  @media only screen and (max-width: 960px) {
    display: block;

    .widget-area {
      margin-top: 5rem;
    }
  }
`;

export const StyledInfoItem = styled.div`
  .info-title {
    font-weight: 600;
    font-size: 14px;
    color: #222222;
    margin-bottom: 1rem;
  }

  .charge-bearer {
    color: #722ed1;
    background-color: #f9f0ff;
    font-size: 12px;
  }

  .info-value {
    font-weight: 400;
    font-size: 14px;
  }
`;

export const StyledModalContentWrapper = styled.div`
  padding: 1.6rem 2.4rem;
  /* background-color: #f5f5f5; */
  background-color: #fff;
  .right-side {
    text-align: right;
  }
  .left-side {
    text-align: left;
  }
  .center {
    text-align: center;
  }
  @media (max-width: 500px) {
    .right-side {
      text-align: left;
    }
    .left-side {
      text-align: left;
    }
    .center {
      text-align: left;
    }
  }
`;
